export default class FilterButton {
  element: HTMLButtonElement;
  methods: any;

  constructor(element: HTMLButtonElement, methods: object) {
    this.element = element;
    this.methods = methods;
    this.element.addEventListener('click', (event) => {
      const button = (event.target as HTMLButtonElement);
      if(this.element.classList.contains('js-reset')) {
        return this.resetFilter(event);
      }
      const values = button.getAttribute('data-value');
      if (values) {
        this.setFilterByPageType(values, button)
      }
    })
  }

  setFilterByPageType = (value: string, button: HTMLButtonElement) => {
    const resetButton = document.getElementsByClassName('js-reset')[0];
    resetButton.classList.remove('hidden');
    const filterValues = value.split(',').map((string) => string.trim());
    this.methods.updateFilters(filterValues);
    button.classList.add('active');
  };

  resetFilter = (event: Event) => {
    const parent = (event.currentTarget as HTMLButtonElement).parentElement;
    const allButtons = parent.querySelectorAll('.btn');
    const elements = [].slice.call(allButtons);
    elements.forEach((el: HTMLButtonElement) => {
      el.classList.remove('active');
    });
    this.methods.resetFilters();
    this.methods.hideResetButton();

  };
}
